/**
 * Cycle Count Constants
 * Shared constants for cycle count management
 */

// Status options for filtering and display
export const STATUS_OPTIONS = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Preparing', value: 'PREPARING' },
    { label: 'Pending Manager Approval', value: 'PENDING_MANAGER_APPROVAL' },
    { label: 'Pending Finance Approval', value: 'PENDING_FINANCE_APPROVAL' },
    { label: 'Complete', value: 'COMPLETE' },
    { label: 'Error', value: 'ERROR' },
];

// Type options for filtering and display
export const TYPE_OPTIONS = [
    { label: 'Partial', value: 'partial' },
    { label: 'Full', value: 'full' },
];

// Status display mapping
export const STATUS_DISPLAY_MAPPING = {
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    PREPARING: 'Preparing',
    PENDING_MANAGER_APPROVAL: 'Pending Manager Approval',
    PENDING_FINANCE_APPROVAL: 'Pending Finance Approval',
    COMPLETE: 'Complete',
    ERROR: 'Error',
};

// Type display mapping
export const TYPE_DISPLAY_MAPPING = {
    partial: 'Partial',
    full: 'Full',
};

// Sort options
export const SORT_OPTIONS = [
    { label: 'Cycle Count Name', value: 'name asc', directionLabel: 'Ascending' },
    { label: 'Cycle Count Name', value: 'name desc', directionLabel: 'Descending' },
    { label: 'Date Created', value: 'createdAt asc', directionLabel: 'Oldest first' },
    { label: 'Date Created', value: 'createdAt desc', directionLabel: 'Newest first' },
    { label: 'Date Updated', value: 'updatedAt asc', directionLabel: 'Oldest first' },
    { label: 'Date Updated', value: 'updatedAt desc', directionLabel: 'Newest first' },
];

export const RESOURCE_NAME = {
    singular: 'cycle count',
    plural: 'cycle counts',
};

// Pagination
export const ITEMS_PER_PAGE = 12;

// Action button text
export const ACTION_BUTTONS = {
    APPROVE: 'Approve',
    REJECT: 'Reject',
    EXPORT: 'Export',
    SUBMIT_FOR_APPROVAL: 'Submit for Approval',
};

// Approval workflow permissions
export const APPROVAL_PERMISSIONS = {
    MANAGER: 'ccApprove',
    FINANCE: 'ccApprove',
};

export const PERFORM_STATUSES = ['PENDING', 'IN_PROGRESS', 'ERROR', 'PREPARING'];

export const STATUS = STATUS_OPTIONS.reduce((acc, curr) => {
    acc[curr.value] = curr.value;
    return acc;
}, {});
